<template>
    <div class="dashboard">
        <div class="content-area">
            <base-header
                :menu-listing="menuListing"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */

    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            menuListing: [
                {
                    anchorLink: '/system-users/users',
                    menuLabel: 'System Users',
                    name: 'view-system-users',
                    permission: ['view-system-users', 'manage-system-users'],
                },
                {
                    anchorLink: '/system-users/roles',
                    menuLabel: 'Roles & Permissions',
                    name: 'view-roles',
                    permission: ['view-roles', 'manage-roles'],
                },
                {
                    anchorLink: '/system-users/data-segments',
                    menuLabel: 'Data Segments',
                    name: 'view-data-segments',
                    permission: ['view-data-segments', 'manage-data-segments'],
                },
                {
                    anchorLink: '/system-users/application-access',
                    menuLabel: 'Application Access',
                    name: 'view-application-access',
                    permission: [
                        'view-application-access',
                        'manage-application-access',
                    ],
                },
            ],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
